module.exports = __webpack_public_path__ + "static/media/Profit.b69eaaca.svg";